import { render, staticRenderFns } from "./IntendBrands.vue?vue&type=template&id=1348d521&"
import script from "./IntendBrands.vue?vue&type=script&lang=js&"
export * from "./IntendBrands.vue?vue&type=script&lang=js&"
import style0 from "./IntendBrands.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports